import React from 'react'
import Grid from '@material-ui/core/Grid'
import Modal from '@material-ui/core/Modal'
import Box from '@material-ui/core/Box'
import IconButton from '@material-ui/core/IconButton'
import Close from '@material-ui/icons/Close'
import Button from '@material-ui/core/Button'
import ChevronLeft from '@material-ui/icons/ChevronLeft'
import ChevronRight from '@material-ui/icons/ChevronRight'
import { ProductParameterValue } from '../../../../product/model'
import { productParameterExpansionStyles } from './styles'

export interface ProductParameterExpansionDesignLibraryProps {
    close: () => void
    value: ProductParameterValue
    valueSelect: (value: any) => void
}

export const ProductParameterExpansionDesignLibrary = (props: ProductParameterExpansionDesignLibraryProps) => {
    const classes = productParameterExpansionStyles(props)
    const [currentIndex, setCurrentIndex] = React.useState(0)
    const [tileSize, setTileSize] = React.useState(82)
    const cls = (index: number) => {
        if (currentIndex - 2 === index)
            return 'item prev2'
        if (currentIndex - 1 === index)
            return 'item prev1'
        else if (currentIndex === index)
            return `item current`
        else if (currentIndex + 1 === index)
            return 'item next1'
        else if (currentIndex + 2 === index)
            return 'item next2'
        return 'item hidden'
    }
    const transform = (index: number) => {
        if (currentIndex - 2 === index)
            return 'translateX(20%) rotateY(35deg) scale(.7)'
        if (currentIndex - 1 === index)
            return `translateX(50%) rotateY(30deg) scale(.8)`
        else if (currentIndex === index)
            return `translateX(100%)`
        else if (currentIndex + 1 === index)
            return `translateX(150%) rotateY(-30deg) scale(.8)`
        else if (currentIndex + 2 === index)
            return `translateX(180%) rotateY(-35deg) scale(.7)`
        return ''
    }
    const allowedValues = props.value.valueProvider.list.filter(it => !it.disabled)
    const select = () => {
        const valueSelected = { ...props.value }
        valueSelected.valueSelected = allowedValues[currentIndex]
        props.valueSelect(valueSelected)
    }
    return !props.value ? null : <Modal open={true} className={classes.modal}>
        <Box height='100%' display='flex' justifyContent='center' alignItems='center'>
            <Grid item container direction='column' justify='center' className='ProductParameterExpansion-designLibraryGalleryContainer'>
                <IconButton color='primary' className='ProductParameterExpansion-designLibraryGalleryCloseButton' onClick={() => props.close()}>
                    <Close />
                </IconButton>
                <Grid item container wrap='nowrap' alignItems='center'>
                    <Grid item>
                        <Button variant='contained' color='primary' className='ProductParameterExpansion-designLibraryGalleryArrowButton' onClick={() => setCurrentIndex(Math.max(currentIndex - 1, 0))}>
                            <ChevronLeft />
                        </Button>
                    </Grid>
                    <Grid item style={{ flexGrow: 1 }}>
                        <Grid container
                            className='ProductParameterExpansion-designLibraryGallery'
                            wrap='nowrap'
                            alignItems='center'
                            style={{ height: `${tileSize * 1.2}px` }}
                            ref={el => { if (el) setTileSize(el.clientWidth / 3.0) }}>
                            {allowedValues.map((item, index) => <Grid
                                key={index}
                                item
                                className={cls(index)}
                                style={{ transform: transform(index), width: `${tileSize}px`, height: `${tileSize}px` }}
                                onClick={() => setCurrentIndex(index)}
                            >
                                <img src={item.label} style={{ maxWidth: '100%', maxHeight: '100%' }} />
                            </Grid>)}
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Button variant='contained' color='primary' className='ProductParameterExpansion-designLibraryGalleryArrowButton' onClick={() => setCurrentIndex(Math.min(currentIndex + 1, allowedValues.length - 1))}>
                            <ChevronRight />
                        </Button>
                    </Grid>
                </Grid>
                <Grid item container justify='center'>
                    <Button variant='contained' color='primary' onClick={() => select()}>Select</Button>
                </Grid>
            </Grid>
        </Box>
    </Modal>
}